export default __webpack_public_path__ + "assets/hero-medium.a766c30f.jpg";